import { render, staticRenderFns } from "./WallConfigurator.vue?vue&type=template&id=42e1188f&"
import script from "./WallConfigurator.vue?vue&type=script&lang=js&"
export * from "./WallConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e1188f')) {
      api.createRecord('42e1188f', component.options)
    } else {
      api.reload('42e1188f', component.options)
    }
    module.hot.accept("./WallConfigurator.vue?vue&type=template&id=42e1188f&", function () {
      api.rerender('42e1188f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/configurator/WallConfigurator.vue"
export default component.exports